/* HYRAYSE Brand Experiences – Seitenlogik (Paketvorauswahl, Anfrageformular, Tracking nach Consent)
   Gemeinsame Helfer liegen auf window.HYBE und werden von Event-Anmeldung und Michael-Widget genutzt.
   Grundsätze: keine personenbezogenen Daten an Analytics, Tracking nur mit Einwilligung (Shopify Customer Privacy API),
   Erfolg wird nur angezeigt, wenn der Server die Speicherung bestätigt. */
(function () {
  'use strict';
  if (window.HYBE && window.HYBE.__ready) return;

  var HYBE = window.HYBE = window.HYBE || {};
  HYBE.__ready = true;

  /* ---------- Kampagnenparameter (nur für diese Sitzung, keine Klick-IDs im Klartext) ---------- */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  HYBE.attribution = function () {
    var stored = null;
    try { stored = JSON.parse(sessionStorage.getItem('hybe.attr') || 'null'); } catch (e) { stored = null; }
    var q = new URLSearchParams(location.search);
    var utm = {}, has = false;
    UTM_KEYS.forEach(function (k) { var v = q.get(k); if (v) { utm[k.replace('utm_', '')] = v.slice(0, 120); has = true; } });
    if (has || !stored) {
      stored = {
        utm: utm,
        click_ids: { gclid: q.has('gclid'), fbclid: q.has('fbclid') },
        referrer_host: (function () { try { return document.referrer ? new URL(document.referrer).hostname : null; } catch (e) { return null; } })(),
        landing_path: location.pathname,
        landing_at: new Date().toISOString()
      };
      try { sessionStorage.setItem('hybe.attr', JSON.stringify(stored)); } catch (e) { /* privat-modus */ }
    }
    return stored;
  };
  HYBE.attribution();

  /* ---------- Consent-gesteuertes Tracking ---------- */
  var consentApiRequested = false;
  function loadConsentApi() {
    if (consentApiRequested) return;
    consentApiRequested = true;
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      }
    } catch (e) { /* ignorieren */ }
  }
  loadConsentApi();
  HYBE.analyticsAllowed = function () {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
    } catch (e) { /* ignorieren */ }
    return false; // ohne nachweisbare Einwilligung kein Tracking
  };
  var PII = /(name|mail|phone|telefon|tel|company|unternehmen|message|nachricht|website)/i;
  HYBE.track = function (event, params) {
    var clean = {};
    Object.keys(params || {}).forEach(function (k) {
      var v = params[k];
      if (PII.test(k)) return; // Schutz gegen versehentliche personenbezogene Felder
      if (typeof v === 'string' && /@|\+?\d[\d\s\/-]{6,}/.test(v)) return;
      clean[k] = v;
    });
    clean.page_context = 'brand_experiences';
    HYBE._lastTrack = { event: event, params: clean, sent: false };
    if (!HYBE.analyticsAllowed()) return false;
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, clean)); } catch (e) { /* */ }
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(event, clean); } catch (e) { /* */ }
    HYBE._lastTrack.sent = true;
    return true;
  };

  /* ---------- Senden an CRM / Test-Endpunkt ---------- */
  HYBE.uuid = function () {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); });
  };
  /* cfg: {type:'supabase_rpc'|'json'|'mock'|'none', url, key, rpc}  → Promise<{ok, data, error}> */
  HYBE.post = function (cfg, payload) {
    var type = cfg.type || 'none';
    if (type === 'none' || (type !== 'mock' && !cfg.url)) return Promise.resolve({ ok: false, error: 'unconfigured' });
    if (type === 'mock' || (type === 'supabase_rpc' && !cfg.key)) {
      if (type === 'supabase_rpc') return Promise.resolve({ ok: false, error: 'unconfigured' });
      return HYBE.mock(payload);
    }
    var url, headers = { 'Content-Type': 'application/json' }, body;
    if (type === 'supabase_rpc') {
      url = cfg.url.replace(/\/+$/, '') + '/rest/v1/rpc/' + encodeURIComponent(cfg.rpc);
      headers.apikey = cfg.key; headers.Authorization = 'Bearer ' + cfg.key;
      body = JSON.stringify({ p: payload });
    } else {
      // JSON-POST, z. B. an eine Supabase Edge Function (öffentlicher Schlüssel optional)
      url = cfg.url; body = JSON.stringify(payload);
      if (cfg.key) { headers.apikey = cfg.key; headers.Authorization = 'Bearer ' + cfg.key; }
    }
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
    return fetch(url, { method: 'POST', headers: headers, body: body, signal: ctrl ? ctrl.signal : undefined, credentials: 'omit' })
      .then(function (res) {
        clearTimeout(timer);
        return res.text().then(function (txt) {
          var data = null; try { data = txt ? JSON.parse(txt) : null; } catch (e) { data = null; }
          if (!res.ok) return { ok: false, error: (data && (data.error || data.code || data.message)) || ('http_' + res.status), status: res.status, data: data };
          if (data && data.ok === false) return { ok: false, error: data.error || 'rejected', data: data };
          return { ok: true, data: data || {} };
        });
      })
      .catch(function (err) { clearTimeout(timer); return { ok: false, error: err && err.name === 'AbortError' ? 'timeout' : 'network' }; });
  };
  /* Vorschau-Simulation: speichert nichts. Fehlerfälle zum Testen: Unternehmen/Vorname enthält "FEHLER" → Serverfehler,
     "TIMEOUT" → Zeitüberschreitung; Event-Anmeldung: Nachname "VOLL" → ausgebucht, "WARTE" → Warteliste. */
  HYBE.mockLog = [];
  HYBE.mock = function (payload) {
    HYBE.mockLog.push(JSON.parse(JSON.stringify(payload)));
    var probe = JSON.stringify(payload);
    return new Promise(function (resolve) {
      setTimeout(function () {
        if (/FEHLER/.test(probe)) return resolve({ ok: false, error: 'server_error', status: 500 });
        if (/TIMEOUT/.test(probe)) return resolve({ ok: false, error: 'timeout' });
        if (payload.kind === 'brand_event_registration') {
          var ln = (payload.participant && payload.participant.last_name) || '';
          if (/VOLL/.test(ln)) return resolve({ ok: true, data: { ok: true, status: 'full', waitlist_available: false } });
          if (/WARTE/.test(ln)) return resolve({ ok: true, data: { ok: true, status: 'waitlist', doi_pending: true } });
          return resolve({ ok: true, data: { ok: true, status: payload.event && payload.event.mode === 'lottery' ? 'lottery_entered' : 'registered', doi_pending: true } });
        }
        resolve({ ok: true, data: { ok: true, inquiry_id: 'mock-' + Date.now(), reference: 'TEST-' + String(Date.now()).slice(-5), confirmation_mail: false } });
      }, 600);
    });
  };

  /* ---------- Hilfen ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  HYBE.$ = $; HYBE.$all = $all;
  HYBE.esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  HYBE.isEmail = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); };
  HYBE.isPhone = function (v) { return /^\+?[0-9][0-9\s()\/-]{5,}$/.test(v); };
  HYBE.isTest = function (flag) { return flag === true || flag === 'true' || /[?&]hybe_test=1/.test(location.search); };

  /* ---------- Landingpage: Paketvorauswahl + Anfrageformular ---------- */
  function initInquiry(form) {
    var root = form.closest('.hybe') || document;
    var cfg = { type: form.dataset.endpointType, url: form.dataset.endpoint, key: form.dataset.endpointKey, rpc: form.dataset.rpc || 'brand_inquiry_submit' };
    var testMode = HYBE.isTest(form.dataset.test);
    var status = $('[data-hybe-status]', form);
    var success = $('[data-hybe-success]', root);
    var submitBtn = $('[data-hybe-submit]', form);
    var consultBox = $('[data-hybe-consult-box]', form);
    var pkgSelect = form.elements['package'];
    var clientRef = null;

    function setConsult(on) {
      var r = form.querySelector('input[name="start"][value="' + (on ? 'consult' : 'offer') + '"]');
      if (r) r.checked = true;
      consultBox.hidden = !on;
    }
    $all('input[name="start"]', form).forEach(function (r) { r.addEventListener('change', function () { setConsult(form.elements.start.value === 'consult'); }); });

    function markPackage(key) {
      $all('[data-hybe-package-card]', root).forEach(function (c) { c.classList.toggle('is-selected', c.getAttribute('data-hybe-package-card') === key); });
    }
    function selectPackage(key) {
      if (!pkgSelect) return;
      var ok = Array.prototype.some.call(pkgSelect.options, function (o) { return o.value === key; });
      if (ok) { pkgSelect.value = key; markPackage(key); clearErr('package'); }
    }
    pkgSelect && pkgSelect.addEventListener('change', function () { markPackage(pkgSelect.value); });

    function goToForm(focusEl) {
      var sec = document.getElementById('anfrage');
      if (sec) sec.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      setTimeout(function () { try { (focusEl || form.elements.company).focus({ preventScroll: true }); } catch (e) { /* */ } }, 450);
    }
    $all('[data-hybe-package]', root).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var key = a.getAttribute('data-hybe-package');
        selectPackage(key);
        HYBE.track('brand_package_selected', { package: key });
        if (!success.hidden) return;
        goToForm();
      });
    });
    $all('[data-hybe-cta]', root).forEach(function (a) {
      if (a.hasAttribute('data-hybe-package')) return;
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        HYBE.track('brand_cta_click', { cta: a.getAttribute('data-hybe-cta') });
        if (href.charAt(0) !== '#') return;
        e.preventDefault();
        if (a.hasAttribute('data-hybe-consult')) setConsult(true);
        if (!success.hidden) { success.scrollIntoView({ block: 'start' }); return; }
        goToForm(a.hasAttribute('data-hybe-consult') ? $('input[name="slot_1_date"]', form) : null);
      });
    });

    // Vorauswahl über Link: ?paket=brand_series  ·  ?beratung=1
    var q = new URLSearchParams(location.search);
    if (q.get('paket')) selectPackage(q.get('paket'));
    if (q.get('beratung') === '1') setConsult(true);

    // Mindestdatum für Wunschtermine = morgen
    var tomorrow = new Date(Date.now() + 864e5).toISOString().slice(0, 10);
    $all('input[type="date"]', form).forEach(function (d) { d.min = tomorrow; });

    function setErr(name, msg) {
      var el = form.elements[name]; var box = $('[data-err-for="' + name + '"]', form);
      if (el && el.setAttribute) el.setAttribute('aria-invalid', 'true');
      if (box) box.textContent = msg;
    }
    function clearErr(name) {
      var el = form.elements[name]; var box = $('[data-err-for="' + name + '"]', form);
      if (el && el.removeAttribute) el.removeAttribute('aria-invalid');
      if (box) box.textContent = '';
    }
    ['company', 'first_name', 'last_name', 'email', 'phone', 'website', 'message'].forEach(function (n) {
      var el = form.elements[n]; if (el) el.addEventListener('input', function () { clearErr(n); });
    });

    function val(n) { var el = form.elements[n]; return el ? String(el.value || '').trim() : ''; }
    function validate() {
      var errs = {};
      if (val('company').length < 2) errs.company = 'Bitte gib dein Unternehmen oder deine Marke an.';
      if (!val('first_name')) errs.first_name = 'Bitte gib deinen Vornamen an.';
      if (!val('last_name')) errs.last_name = 'Bitte gib deinen Nachnamen an.';
      if (!HYBE.isEmail(val('email'))) errs.email = 'Bitte gib eine gültige E-Mail-Adresse an.';
      if (val('phone') && !HYBE.isPhone(val('phone'))) errs.phone = 'Bitte prüfe die Telefonnummer.';
      if (!val('package')) errs.package = 'Bitte wähle ein Paket – oder „Noch offen“.';
      if (val('message').length < 10) errs.message = 'Beschreibe kurz dein Produkt und dein Ziel (mind. 10 Zeichen).';
      if (form.elements.start.value === 'consult') {
        if (!val('slot_1_date')) errs.slots = 'Bitte nenne mindestens einen Wunschtermin.';
        else if (val('slot_1_date') < tomorrow) errs.slots = 'Bitte wähle einen Termin ab morgen.';
      }
      ['company', 'first_name', 'last_name', 'email', 'phone', 'package', 'message', 'slots'].forEach(clearErr);
      Object.keys(errs).forEach(function (k) { setErr(k, errs[k]); });
      return errs;
    }

    function pkgLabel(key) {
      var o = pkgSelect && Array.prototype.find.call(pkgSelect.options, function (x) { return x.value === key; });
      return o ? o.textContent : key;
    }

    HYBE.buildInquiry = function (data, channel) {
      var attr = HYBE.attribution();
      return {
        kind: 'brand_inquiry', schema_version: 1, test: testMode,
        client_ref: data.client_ref || HYBE.uuid(),
        company: data.company,
        contact: { first_name: data.first_name || null, last_name: data.last_name || null, email: data.email || null, phone: data.phone || null, website: data.website || null, preferred_channel: data.preferred_channel || 'email' },
        package: data.package || 'undecided',
        period: data.period || null,
        product: data.product || null,
        goal: data.goal || null,
        message: data.message || null,
        consult: { requested: !!data.consult, slots: data.slots || [], booking_link_shown: !!form.dataset.bookingUrl },
        handoff_requested: !!data.handoff,
        source: { channel: channel, page_context: 'brand_experiences', page_path: location.pathname, view: new URLSearchParams(location.search).get('view') || null,
          utm: attr.utm, click_ids: attr.click_ids, referrer_host: attr.referrer_host, landing_at: attr.landing_at },
        locale: (document.documentElement.lang || 'de').slice(0, 2),
        privacy_notice_version: 'brand-inquiry-2026-10-08-entwurf',
        client_submitted_at: new Date().toISOString()
      };
    };
    HYBE.inquiryCfg = cfg;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      status.className = 'hybe-form__status'; status.textContent = '';
      if (val('hp_url')) { showSuccess({ reference: null }, collect(), true); return; } // Bot: nichts senden
      var errs = validate();
      var keys = Object.keys(errs);
      if (keys.length) {
        status.className = 'hybe-form__status hybe-form__status--error';
        status.textContent = form.dataset.msgValidation;
        var first = keys[0] === 'slots' ? form.elements.slot_1_date : form.elements[keys[0]];
        if (first && first.focus) first.focus();
        return;
      }
      var data = collect();
      if (!clientRef) clientRef = HYBE.uuid();
      data.client_ref = clientRef;
      var payload = HYBE.buildInquiry(data, 'brand_experiences_form');
      submitBtn.disabled = true; submitBtn.setAttribute('aria-busy', 'true');
      var oldLabel = submitBtn.textContent; submitBtn.textContent = 'Wird gesendet …';
      HYBE.post(cfg, payload).then(function (r) {
        submitBtn.disabled = false; submitBtn.removeAttribute('aria-busy'); submitBtn.textContent = oldLabel;
        if (!r.ok) {
          status.className = 'hybe-form__status hybe-form__status--error';
          status.textContent = r.error === 'unconfigured' ? form.dataset.msgUnconfigured : form.dataset.msgNetwork;
          return;
        }
        HYBE.track('brand_inquiry_submitted', { package: payload.package, consult_requested: payload.consult.requested, source: 'form', test: testMode });
        if (payload.consult.requested) HYBE.track('brand_consult_requested', { source: 'form', test: testMode });
        showSuccess(r.data || {}, data, false);
        clientRef = null;
      });
    });

    function collect() {
      var slots = [];
      [1, 2, 3].forEach(function (n) { var d = val('slot_' + n + '_date'); if (d) slots.push({ date: d, daypart: val('slot_' + n + '_time') || null }); });
      return {
        company: val('company'), first_name: val('first_name'), last_name: val('last_name'), email: val('email'),
        phone: val('phone'), website: val('website'), package: val('package'), period: val('period'), message: val('message'),
        consult: form.elements.start.value === 'consult', slots: form.elements.start.value === 'consult' ? slots : []
      };
    }

    function showSuccess(resp, d, silent) {
      var title = $('[data-hybe-success-title]', success), text = $('[data-hybe-success-text]', success),
          dl = $('[data-hybe-summary]', success), next = $('[data-hybe-success-next]', success);
      title.textContent = 'Danke' + (d.first_name ? ', ' + d.first_name : '') + '! Deine Anfrage ist bei uns angekommen.';
      text.innerHTML = (resp.reference ? 'Deine Referenz: <strong>' + HYBE.esc(resp.reference) + '</strong>. ' : '') +
        (resp.confirmation_mail ? 'Eine Bestätigung mit dieser Zusammenfassung haben wir an ' + HYBE.esc(d.email) + ' geschickt.' : 'Hier ist deine Zusammenfassung:');
      var rows = [['Unternehmen', d.company], ['Ansprechperson', (d.first_name + ' ' + d.last_name).trim()], ['E-Mail', d.email]];
      if (d.phone) rows.push(['Telefon', d.phone]);
      if (d.website) rows.push(['Website/Instagram', d.website]);
      rows.push(['Paket', d.package === 'undecided' ? 'Noch offen' : pkgLabel(d.package)]);
      if (d.period) rows.push(['Wunschzeitraum', d.period]);
      if (d.consult) rows.push(['Beratungsgespräch', d.slots.map(function (s) { return new Date(s.date + 'T12:00:00').toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' }) + (s.daypart ? ' (' + s.daypart + ')' : ''); }).join(', ') + ' – angefragt, noch nicht bestätigt']);
      dl.innerHTML = rows.map(function (r) { return '<dt>' + HYBE.esc(r[0]) + '</dt><dd>' + HYBE.esc(r[1]) + '</dd>'; }).join('');
      next.textContent = d.consult
        ? 'Nächster Schritt: Wir melden uns mit einem Terminvorschlag für das Beratungsgespräch. Erst mit unserer Bestätigung steht der Termin fest.'
        : 'Nächster Schritt: Wir melden uns per E-Mail bei dir, um Format, Ablauf und mögliche Termine abzustimmen.';
      form.hidden = true; success.hidden = false;
      if (!silent) success.focus();
    }
  }

  function boot() {
    $all('form[data-hybe-inquiry]').forEach(initInquiry);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
